import req from './request'

const ENDPOINTS = {
    create:           '/chats/v2/common/create',
    list:             '/chats/v2/common/list',
    historyList:      '/chats/v2/histories/list',
    historyMessages:  '/chats/v2/histories/messages/list',
    totalCounter:     '/chats/v2/common/total-counter',
    view:             '/chats/v2/common/view/',
    reference:        '/chats/v2/common/reference',
    assign:           '/chats/v2/common/assign/',
    returnToList:     '/chats/v2/common/return-to-list/',
    endChat:          '/chats/v2/common/end/',
    driversList:      '/chats/v2/common/drivers-list',
    changeDepartment: '/chats/v2/common/change-department/',
    setCategory:      '/chats/v2/common/set-category/',
    messages:         '/chats/v2/messages/list/',
    createMessage:    '/chats/v2/messages/create/',
    downloadFile:     '/chats/v2/messages/download-file/',
    downloadHistoryFile: '/chats/v2/histories/messages/download-file/',
    historyById:      '/chats/v2/histories/messages/history/',
    fcmToken:         '/profile/auth-firebase',
}

export default {
    createChat(payload) {
        return req.post(payload, ENDPOINTS.create)
    },
    getList({ type, source }) {
        return req.get({ type, source }, ENDPOINTS.list)
    },
    getHistoryList(params) {
        return req.get(params, ENDPOINTS.historyList)
    },
    getHistoryMessages(customerId, page = 1) {
        return req.get({ id: customerId, page }, ENDPOINTS.historyMessages)
    },
    getTotalCounter() {
        return req.get(null, ENDPOINTS.totalCounter)
    },
    getView(id) {
        return req.get(null, ENDPOINTS.view, id)
    },
    getReference() {
        return req.get(null, ENDPOINTS.reference)
    },
    assign(id, payload) {
        return req.post(payload, ENDPOINTS.assign, id)
    },
    returnToList(id, payload) {
        return req.post(payload, ENDPOINTS.returnToList, id)
    },
    endChat(id, payload) {
        return req.post(payload, ENDPOINTS.endChat, id)
    },
    getDriversList(payload) {
        return req.post(payload, ENDPOINTS.driversList)
    },
    changeDepartment(id, payload) {
        return req.post(payload, ENDPOINTS.changeDepartment, id)
    },
    setCategory(id, payload) {
        return req.post(payload, ENDPOINTS.setCategory, id)
    },
    getMessages(id, page = 1) {
        return req.get(null, ENDPOINTS.messages, `${id}?page=${page}`)
    },
    createMessage(id, payload) {
        return req.post(payload, ENDPOINTS.createMessage, id)
    },

    downloadFile(chatId, messageId) {
        return req.get(null, ENDPOINTS.downloadFile, `${chatId}/${messageId}`)
    },

    downloadHistoryFile(messageId) {
        return req.get(null, ENDPOINTS.downloadHistoryFile, messageId)
    },

    getHistoryById(id, page = 1) {
        return req.get({ page }, ENDPOINTS.historyById, String(id))
    },

    registerFcmToken(payload) {
        return req.put(payload, ENDPOINTS.fcmToken)
    },
}
